export function MenuItemViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;
  const { companyId, siteId, scenarioId } = context;

  return joint.shapes.html.AbstractElementView.extend({

    template: [
      '<div class="html-element action">',
      '<div class="action-description"></div>',
      '<div class="answer-edit-container"><span class="glyphicon glyphicon-pencil answer-edit"></span></div>',
      '</div>'
    ].join(''),

    initialize: function() {
      joint.shapes.html.AbstractElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.answer-edit').on('click', () => this.editMenuItem());
    },

    editMenuItem: function() {
      this.editMenuItemPromise().then(result => {
        let parent = this.model.getAncestors()[0];
        let parentView = this.paper.findViewByModel(parent);
  
        if(result.type === 'delete') {
          this.model.remove.call(this.model);
          //we save the graph on remove cell event
        }
        else if (result.type === 'edit') {
          this.updatePortAndLink(result.menuItem); // add/remove port first, to prevent exceptions on link model update
          this.model.set('menuItem', result.menuItem);
          callbacks.updateSerializedGraph(this.model.graph);
        }
        //Resize needed for both editing and deleting
        parentView.resizeBox();
      })
    },

    editMenuItemPromise: function() {
      return services.$uibModal.open({
        animation: true,
        template:  require('./chooseMenuItemType.modal.html'),
        controller: 'chooseMenuItemTypeController',
        resolve: {
          menuItem: angular.copy(this.model.get('menuItem')),

          isEditMenuItem: true,
        }
      }).result
    },

    /**
     * Adds/removes the element's out port if it just changed to
     * a menu item type that can/cannot be connected to another box
     */
    updatePortAndLink: function(newMenuItem) {
      if (this.model.hasPort('out') && !itemTypeHasOutPort(newMenuItem)) {
        this.model.graph.removeLinks(this.model);
        this.model.removeOutPort('out');
      } else if (!this.model.hasPort('out') && itemTypeHasOutPort(newMenuItem)) {
        this.model.addOutPort('out');
      }
    },


    updateBox: function() {
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
      if(this.paper) {
        this.updatePortAndLink(this.model.get('menuItem'));
        let menuItemDescription;
        const title = this.model.get('menuItem').title;
        const urlOrPayload = this.model.get('menuItem').urlOrPayload;

        switch (this.model.get('menuItem').type) {
          case 'alcmeon_restart_conversation':
            menuItemDescription = title;
            break;
          case 'web_url':
          case 'postback':
              menuItemDescription = title + ' - '
                                  + urlOrPayload.replace(/\//g, '\u200B/'); // allow browser to break lines before slashes
            break;
            case 'postback_to_box':
              menuItemDescription = title;
            break;
          default:
            console.warn('addMenuItem: unexpected menu item type ' + result.actionType);
            break;
        }
            
        this.$box.find('.action-description').text(menuItemDescription);
      }
    },

    // Drag & drop
    onMenuItemPointerMove: function() {
      let parent = this.model.getAncestors()[0];
      let parentView = this.paper.findViewByModel(parent);
      let embeds = parent.getEmbeddedCells();
      let index = embeds.indexOf(this.model);

      joint.shapes.html.AnswerView.prototype.moveAnswer.call(this, index, embeds, embeds.length, parent, parentView, callbacks);
    }

  });
}


/**
 * Tells whether this menu item should have an outPort
 * and hence can be connected to other boxes of the graph,
 * depending on its selected type.
 */
function itemTypeHasOutPort(menuItem) {
  return menuItem.type === 'postback_to_box';
}
